import { useSelector } from 'react-redux';

import { StateType } from '@app/types/reducer-state';

const useGetCurrentUserId = () => {
  const currentUser = useSelector((state: StateType) => state.auth.user);
  return currentUser?._id;
};

export default useGetCurrentUserId;
